import { useSelector } from 'react-redux'

import type { CollectionUUID } from '@library/menu-service'

import { getCurrentCollectionId } from 'selectors/menu-collections/getCurrentCollectionId'

export const useCurrentCollectionId = (): CollectionUUID => useSelector(getCurrentCollectionId)
